import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import NoiseOverlay from "@/components/NoiseOverlay";
import { AuthProvider } from "@/context/AuthContext";
import { AmbientAudioProvider } from "@/context/AudioContext";
import AmbientToggle from "@/components/AmbientToggle";
import AlcottHome from "@/pages/AlcottHome";
import Archives from "@/pages/Archives";
import Essay from "@/pages/Essay";
import Horizon from "@/pages/Horizon";
import Experiences from "@/pages/Experiences";
import SybilsSecrets from "@/pages/SybilsSecrets";
import HorizonGate from "@/pages/HorizonGate";
import Society from "@/pages/Society";
import OuterVeil from "@/pages/OuterVeil";
import Gate from "@/pages/Gate";
import Mysteries from "@/pages/Mysteries";
import Sanctum from "@/pages/Sanctum";
import Matriarch from "@/pages/Matriarch";
import Legal from "@/pages/Legal";

// The cosmic "chrome" (grain + ambient audio toggle) belongs to the dark
// Secret Society world only, not the light public publication.
const DARK_ROUTES = ["/society", "/gate", "/sanctum", "/matriarch", "/mysteries", "/veil"];
const Chrome = () => {
  const { pathname } = useLocation();
  const isDark = DARK_ROUTES.some((p) => pathname === p || pathname.startsWith(p + "/") || pathname.startsWith(p));
  if (!isDark) return null;
  return (
    <>
      <NoiseOverlay />
      <AmbientToggle />
    </>
  );
};

function App() {
  return (
    <div className="App relative min-h-screen">
      <AuthProvider>
        <AmbientAudioProvider>
          <BrowserRouter>
            <SmoothScroll>
              <Chrome />
              <Routes>
                {/* Sybils & Society — public publication */}
                <Route path="/" element={<AlcottHome />} />
                <Route path="/archives" element={<Archives />} />
                <Route path="/essay/:slug" element={<Essay />} />
                {/* The Horizon Circle */}
                <Route path="/horizon" element={<Horizon />} />
                <Route path="/experiences" element={<Experiences />} />
                <Route path="/secrets" element={<SybilsSecrets />} />
                <Route path="/horizon/gate" element={<HorizonGate />} />
                {/* The Secret Society (gated, cosmic) */}
                <Route path="/society" element={<Society />} />
                <Route path="/veil" element={<OuterVeil />} />
                <Route path="/gate" element={<Gate />} />
                <Route path="/mysteries" element={<Mysteries />} />
                <Route path="/sanctum" element={<Sanctum />} />
                <Route path="/matriarch" element={<Matriarch />} />
                <Route path="/legal/:slug" element={<Legal />} />
              </Routes>
              <Toaster
                theme="dark"
                position="bottom-center"
                toastOptions={{
                  style: {
                    background: "#0a0a0a",
                    border: "1px solid rgba(197,160,89,0.3)",
                    color: "#fff",
                    fontFamily: "Inter, Outfit, sans-serif",
                  },
                }}
              />
            </SmoothScroll>
          </BrowserRouter>
        </AmbientAudioProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
